import React from "react";
import "./Contact.css";
import { motion } from "framer-motion"; 

function Contact() {
  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <div className="row g-4">
          {/* Left side: info + map */}
          <motion.div
            className="col-lg-6"
            initial={{ x: -50, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="contact-title">
              Get in <span>Touch</span>
            </h2>
            <p className="contact-sub">
              We’re happy to help with quotes, bulk orders, and any questions.
            </p>

            <div className="contact-info">
              <div>
                <i className="bi bi-telephone"></i>
                <a href="tel:+94776500580">+94 776500580</a>
              </div>
              <div>
                <i className="bi bi-whatsapp"></i>
                <a
                  href="https://wa.me/94776500580"
                  target="_blank"
                  rel="noreferrer"
                >
                  WhatsApp Chat
                </a>
              </div>
              <div>
                <i className="bi bi-envelope"></i>
                <a href="mailto:yourhardware@shop.lk">alubomullahardware@gmail.lk</a>
              </div>
              <div>
                <i className="bi bi-geo-alt"></i>
                150E Horana Rd, Panadura 12524
              </div>
            </div>

            {/* Map */}
            <div className="map-wrapper">
              <iframe
                title="map"
                src="https://www.google.com/maps?q=New%20Alubomulla%20Trade%20Center%2C%20Panadura&z=16&output=embed"
                loading="lazy"
              ></iframe>
            </div>
          </motion.div>

          {/* Right side: message form */}
          <motion.div
            className="col-lg-6"
            initial={{ x: 50, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            <div className="contact-card">
              <h5 className="mb-3">Send a Message</h5>
              <form className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">Name</label>
                  <input type="text" className="form-control" required />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Phone</label>
                  <input type="tel" className="form-control" required />
                </div>
                <div className="col-12">
                  <label className="form-label">Message</label>
                  <textarea className="form-control" rows="4"></textarea>
                </div>
                <div className="col-12 d-grid">
                  <button className="btn btn-accent" type="submit">
                    <i className="bi bi-send me-1"></i> Send
                  </button>
                </div>
              </form>
              <p className="small text-muted mt-2">
                By submitting, you agree to be contacted about your request.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
